import { Component } from '@angular/core';

@Component({
  selector: 'uni-filters-fields',
  templateUrl: './uni-filters-fields.component.html',
  styleUrls: ['./uni-filters-fields.component.scss'],
})
export class UniFiltersFieldsComponent {}
